export const NON_SERIALIZABLE_URLS = ['/files/signed_url'];
